import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Flex } from "../../globalStyle";

import NavImg from "../../assets/imgs/mainImg.jpg";

export const Icon = styled.span`
  transition:
    color 0.3s ease,
    background-color 0.3s ease;
  display: flex;
  width: 20px;
  height: 20px;
  display: none;
  @media (max-width: 800px) {
    display: block;
    margin-bottom: 5px;
    width: 15px;
    height: 15px;
  }
  @media (max-width: 560px) {
    margin-bottom: 0;
    width: 13px;
    height: 13px;
  }
`;

export const NavbarWrapper = styled.div`
  ${Flex}
  border-radius: 20px;
  padding: 20px;
  z-index: 900;
  background-color: var(--main-bg);
  transition: padding 0.5s ease;
  position: ${({ sticky }) => (sticky ? "sticky" : null)};
  top: ${({ sticky }) => (sticky ? "10px" : null)};
  padding-right: ${({ sticky }) => (sticky ? "40px" : null)};
  padding-left: ${({ sticky }) => (sticky ? "40px" : null)};
  @media (max-width: 800px) {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 30px;
  }
  @media (max-width: 430px) {
    border-radius: 15px;
  }
`;

export const LinksWrapper = styled.div`
  ${Flex}
  transition: background-color 0.3s ease;
  .active {
    color: var(--main-color);
    &::before,
    &::after {
      width: 50%;
    }
    @media (max-width: 560px) {
      &::before,
      &::after {
        opacity: 1;
        background-color: #4f8b48;
        bottom: -6px;
      }
    }
  }
  @media (max-width: 800px) {
    position: fixed;
    justify-content: space-evenly;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    padding: 10px;
    background-color: var(--main-bg);
    z-index: 999;
    border-radius: 20px;
  }
  @media (max-width: 700px) {
    width: 70%;
  }
  @media (max-width: 560px) {
    padding: 7px;
    border: 1px solid var(--yellow-color);
  }

  @media (max-width: 500px) {
    width: 80%;
  }
`;

export const Link = styled(NavLink)`
  font-family: "Montserrat";
  color: var(--yellow-color);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  transition:
    color 0.3s ease,
    background-color 0.3s ease;
  position: relative;

  ::before {
    content: "";
    width: 0%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: -5px;
    background-color: var(--main-color);
    transition:
      width 0.3s ease,
      opacity 0.3s ease;
  }
  ::after {
    content: "";
    width: 0%;
    height: 2px;
    position: absolute;
    right: 0;
    bottom: -5px;
    background-color: var(--main-color);
    transition:
      width 0.5s ease,
      opacity 0.3s ease;
  }

  :hover {
    /* color: var(--hover-color); */
    color: var(--main-color);
    &::before,
    &::after {
      width: 50%;
    }
  }
  :not(:last-child) {
    margin-right: 30px;
  }
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: unset;
    :not(:last-child) {
      margin-right: 0;
    }
    color: #fff;
    &::before,
    &::after {
      opacity: 0;
      width: 100%;
    }
  }
  @media (max-width: 560px) {
    font-size: 0;
    background-color: rgb(43 81 145);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 10px;
    border-radius: 10px;
    :hover {
      background-color: #4f8b48;
      & span {
        color: #fff;
      }
    }
  }
`;

export const Logo = styled(NavLink)`
  color: var(--yellow-color);
  font-family: "Marck Script", cursive;
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 24px;
  /* @media (max-width: 800px) {
    width: 100%;
    text-align: center;
  } */
  position: relative;
  ::before {
    content: "";
    width: 0%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: -8px;
    background-color: var(--main-color);
    transition: width 0.3s ease;
  }
  ::after {
    content: "";
    width: 0%;
    height: 2px;
    position: absolute;
    right: 0;
    bottom: -8px;
    background-color: var(--main-color);
    transition: width 0.5s ease;
  }

  :hover {
    /* color: var(--hover-color); */
    color: var(--main-color);
    &::before,
    &::after {
      width: 50%;
    }
  }
`;

export const MyNavImg = styled.div`
  background-image: url(${NavImg});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: cover;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: none;
  @media (max-width: 800px) {
    display: block;
  }
`;
